<template>
	<div class="home">
		<van-nav-bar
		  	:title="$t('NewPackage.title')"
			left-arrow
		  	@click-left="$router.push('/SetMenu')">
			<van-icon name="./static/img/ok.png" slot="right" @click="createPackage()" style="font-size: 24px;"/>
		</van-nav-bar>
		<van-cell-group>
			<van-field
			    v-model="package.name"
			    :label="$t('NewPackage.packageName')"
			    label-width="120"
			    clearable
			    :placeholder="$t('NewPackage.inputPackageName')"
				/>
			<van-field
			    v-model="package.name_en"
			    :label="$t('NewPackage.enName')"
			    label-width="120"
			    clearable
			    :placeholder="$t('NewPackage.inputPackageName')"
				/>
			<van-cell :title="$t('NewPackage.pic')" title-style="width: 120px;flex:none;">
				<van-uploader :after-read="afterRead" >
					<van-image
						v-if="package.img"
					  	width="55"
					  	fit="contain"
					  	height="55"
					  	:src="package.img"
					/>
					<van-image
						v-else
					  	width="55"
					  	height="55"
					  	src="./static/img/add_img.png"
					/>
				</van-uploader>
			</van-cell>
			<van-panel :title="$t('NewPackage.price')">
				<van-checkbox-group v-model="priceResult">
		  			<van-cell-group>
				  		<van-field
		  				v-model="package.original_price"
		  				:label="$t('NewPackage.oldPrice')"
		  				clearable
		  				:placeholder="$t('NewPackage.inputOldPrice')">
				  			<van-checkbox
		  						@click="togglePrice('o')"
						        :name="'o'"
						        ref="price_checkboxes"
						        slot="left-icon">
							  	<img
							  		style="width: 20px;height: 20px"
							    	slot="icon"
							    	slot-scope="props"
							    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
							  	>
						    </van-checkbox>
						</van-field>
						<van-field
		  				v-model="package.special_price"
		  				:label="$t('NewPackage.newPrice')"
		  				clearable
		  				:placeholder="$t('NewPackage.inputNewPrice')">
				  			<van-checkbox
		  						@click="togglePrice('s')"
						        :name="'s'"
						        ref="price_checkboxes"
						        slot="left-icon">
							  	<img
							  		style="width: 20px;height: 20px"
							    	slot="icon"
							    	slot-scope="props"
							    	:src="props.checked?'./static/img/sele.png':'./static/img/unsele.png'"
							  	>
						    </van-checkbox>
						</van-field>
				  	</van-cell-group>
			  	</van-checkbox-group>
			</van-panel>
			<van-cell :title="$t('NewPackage.commend')" title-style="width: 120px;flex:none;">
				<van-rate
					style="height: 23px;"
				  	v-model="package.level"
				  	:size="20"
				  	gutter="10px"
					icon="./static/img/Recommend-s.png"
				  	void-icon="./static/img/Recommend.png"
				/>
			</van-cell>
		</van-cell-group>
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		package:{
      			name:'',
      			name_en:'',
      			image_id:'',
      			img:'',
      			level:0,
      			store_id:sessionStorage.actShopId,
      			original_price:'',
      			special_price:'',
      			type:'o',
      			category:'p',
      		},
      		priceResult:['o'],
      	}
    },
    mounted:function(){
    },
    methods:{
		afterRead(file) {
      		// 此时可以自行将文件上传至服务器
      		console.log(file);
      		let formData=new FormData();
            formData.append('type','shop');
            formData.append('file',file.file);
      		this.$axios({
                method: 'post',
                url: this.$build+'/api/image',
                headers: {
                	'Content-Type':'multipart/form-data',
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                data:formData,
            }).then(res => {
            	console.log(res);
            	if(res.data.status==200){
            		this.package.image_id=res.data.success.image_id;
            		this.package.img=res.data.success.url;
              //   	this.$toast({
	            	// 	type:'success',
	            	// 	message:res.data.message,
	            	// });           	
            	}else{
            		this.$toast.allowMultiple();
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
                this.$toast({
            		type:'fail',
            		message:this.$t('NewPackage.message'),
        		});
            });
    	},
    	createPackage(){
			if(this.package.name&&this.package.image_id&&this.package.original_price&&this.package.special_price){
				this.$axios({
	                method: 'post',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/menu/store',
	                data:this.package,
	            }).then(res => {
	            	console.log(res);
	            	if(res.data.status==200){
	                	this.$toast({
		            		type:'success',
		            		message:res.data.message,
		            	});
		            	const vm=this;
		            	setTimeout(function(){
	            			vm.$router.push('/EditPackage/'+res.data.data.id);
		            	},1000);     
	            	}else{
	            		this.$toast.allowMultiple();
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	this.$toast({
	            		type:'fail',
	            		message:this.$t('NewPackage.message'),
            		});
	            });
			}else{
				this.$toast(this.$t('NewPackage.toast'));
			}
    	},
    	togglePrice(val){
	    	this.priceResult=[];
	    	this.priceResult.push(val);
	    	this.package.type=this.priceResult[0];
	    },
    }
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
	.home{
		width: 100%;
		height: 100vh;
	}
	.bn{
		border: none;
	}
	/deep/ .van-field__label{
		width: 95px;
	}
	.van-cell__value{
		text-align: left;
		line-height: 36px;
	}
</style>



// WEBPACK FOOTER //
// src/Shop/NewPackage.vue